export const initAddressInputField = (inputName, searchPrefix = 'Беларусь') => {
  new ymaps.SuggestView(inputName, {
    provider: {
      suggest: (request => ymaps.suggest(`${searchPrefix}, ` + request))
    }
  })
}

export const initYmapsLibForAddressInputField = () => {
  const elementId = 'ymaps-addresses'
  if (!document.getElementById(elementId)) {
    const script = document.createElement('script')
    const jsAPIKey = 'cf7cf7ec-fe5e-454c-bb8d-47a4ca1df936'
    const suggestAPIKey = '5df1e5b4-49c7-48fc-b350-28cfa9e45c5c'
    script.id = elementId
    script.src = `https://api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=${jsAPIKey}&suggest_apikey=${suggestAPIKey}&lang=ru_RU`
    document.head.append(script)
  }
}

export const destroyYmapsLibForAddressInputField = () => {
  const elementId = 'ymaps-addresses'
  if (!document.getElementById(elementId)) {
    document.head.querySelector(`script#${elementId}`).remove()
  }
}
